import { useQuery } from '@tanstack/react-query';
import { MealPlan } from '../api/mealPlanApi/interfaces';
import { getMealPlanList } from '../api/mealPlanApi';

export const useGetMealPlansList = (enabled: boolean = true) => {
  return useQuery<MealPlan[]>({
    queryFn: () => getMealPlanList(),
    queryKey: ['meal-plan-list'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled,
  });
};
